import Rtc from './rtc';
import Meeting from './meeting';
import User from './user';
import Stomp from './stomp';
import Chat from './chat';
import SimultaneousInterpretation from './simultaneousInterpretation';
import Members from './members';
import Common from './common';
import Barrage from './barrage';
import Reaction from './reaction';
import Transcribe from './transcribe';
import Focused from './focused';
import Note from './note';
import SpeakWeightInstance from './speakWeight';

export const chat = new Chat();
export const barrage = new Barrage();
export const user = new User();
export const rtc = new Rtc();
export const meeting = new Meeting();
export const stomp = new Stomp();
export const simultaneousInterpretation = new SimultaneousInterpretation();
export const members = new Members();
export const common = new Common();
export const transcribe = new Transcribe();
export const reaction = new Reaction();
export const focused = new Focused();
export const note = new Note();
export const speakWeight = new SpeakWeightInstance();

const models = {
  rtc,
  meeting,
  user,
  stomp,
  chat,
  simultaneousInterpretation,
  members,
  common,
  barrage,
  transcribe,
  reaction,
  focused,
  speakWeight,
  note,
};
(window as any).$m = models;

export type RootStore = typeof models;

export default models;
